import httpService from "./http.service";

class ColorsService {
  getColorsUrl = "/colors";

  getColors = () => {
    return httpService.get(this.getColorsUrl);
  };
  createColor = (model) => {
    return httpService.form("/colors", model, "createColor");
  };
  editColor = (id, model) => {
    return httpService.form("/colors/" + id, model, "editColor", {}, "patch");
  };
  deleteColor = (id) => {
    return httpService.delete("/colors/" + id);
  };
  setColorToCategories = (colorId, categoriesId) => {
    return httpService.post(this.getColorsUrl + "/set-category/" + colorId, categoriesId);
  }
}

const colorsService = new ColorsService();
export default colorsService;
